import { Injectable } from '@angular/core';
import * as d3 from 'd3';

@Injectable()
export class DrawingService {

  svg: any;

  x: number;
  y: number;

  width:number;
  height: number;

  offsetX: number;
  offsetY: number;

  blinkInterval: any;

  scale: number;
  public mode = 'light-mode';

  constructor() {}


  draw(first = true) {
    d3.selectAll('#svg').remove();

    this.width = window.innerWidth * 0.27;
    this.height = this.width * (450 / 330);
    this.offsetY = (window.innerHeight - this.height) / 2;
    this.offsetX = window.innerWidth * 0.58;
    this.scale = this.width / 330;

    if (window.innerWidth < 800) {
      this.width = window.innerWidth * 0.6;
      this.height = this.width * (450 / 330);
      this.offsetY = 0;
      this.offsetX = window.innerWidth * 0.2;
      this.scale = this.width / 330;

    } else if (window.innerWidth < 1000) {
      this.width = window.innerWidth * 0.5;
      this.height = this.width * (450 / 330);
      this.offsetY = this.width * 0.1;
      this.offsetX = window.innerWidth * 0.25;
      this.scale = this.width / 330;

    } else if (window.innerWidth < 1400) {
      this.width = window.innerWidth * 0.4;
      this.height = this.width * (450 / 330);
      this.offsetY = this.width * 0.1;
      this.offsetX = window.innerWidth * 0.3;
      this.scale = this.width / 330;
    }

    this.x = this.width * 0.19;
    this.y = this.x * 0.625;
    // else if (window.innerWidth < 1200) {
    // //   this.offsetY -= 110;
    //   this.offsetX = window.innerWidth * 0.60;
    // }


    this.svg = d3.select('#svgBg')
      .append('svg')
      .attr('width', window.innerWidth > 1400 ? window.innerWidth - 140 : window.innerWidth)
      .attr('height', () => window.innerHeight > window.innerWidth ? window.innerWidth * 0.9 : window.innerHeight)
      .attr('id', 'svg');

    // this.drawHair();
    this.drawEye();
    this.drawLines(first);

    setTimeout(() => {
      this.drawMouth();
      this.drawEar();
    }, (first ? 900 : 0));

    setTimeout(() => {
      this.drawHand();
    }, (first ? 1000 : 0));

    setTimeout(() => {
      this.drawCheek();
    }, (first ? 1400 : 0));

  }


  drawEye() {

    const eyeGroup = this.svg.append('g')
      .attr('transform', 'translate(' + [ (this.offsetX + (this.width * 0.515)), (this.offsetY + (this.height * 0.208))  ] + ')');



    const path_eye = 'M' + (-this.x) + ', 0 Q' + (-0.6 * this.x) + ',' + (-this.y) + ' 0,' + (-this.y) + ' Q' + (0.6 * this.x) + ',' + (-this.y) + ' ' + this.x + ',0 Q' + (0.6 * this.x) + ',' + (this.y) + ' ' + '0,' + this.y +
                ' Q' + (-0.6 * this.x) + ',' + (this.y) + ' ' + (-this.x) + ', 0 Z';

    const path_eyelid = 'M' + (-this.x) + ', 0 Q' + (-0.6 * this.x) + ',' + (-this.y) + ' 0,' + (-this.y) + ' Q' + (0.6 * this.x) + ',' + (-this.y) + ' ' + this.x + ',0 Q' + (0.6 * this.x) + ',' + (-0.5 * this.y) + ' 0,' + (-0.5 * this.y) +
                ' Q' + (-0.6 * this.x) + ',' + (-0.5 * this.y) + ' ' + (-this.x) + ', 0 Z' ;

    const clipPath = eyeGroup.append('clipPath')
      .attr('id', 'ellipse-clip')
      .append('path')
      .attr('d', path_eye);

    const eye = eyeGroup.append('path')
      .attr('d', path_eye)
      .style('fill', '#9fddf9');

    const eyeColor = eyeGroup.append('circle')
      .attr('id', 'eyeColor')
      .attr('class', 'eye')
      .attr('cx', 0)
      .attr('cy', this.y * 0.15)
      .attr('r', this.y * 0.75)
      .style('fill', '#f27fb2')
      .style('shape-rendering', 'geometricPrecision')
      .attr('clip-path', 'url(#ellipse-clip)');

    const iris = eyeGroup.append('circle')
      .attr('id', 'iris')
      .attr('class', 'eye')
      .attr('cx', 0)
      .attr('cy', this.y * 0.15)
      .attr('r', () => this.mode === 'dark-mode' ? this.y * 0.5 : this.y * 0.35)
      .style('fill', '#000')
      .style('shape-rendering', 'geometricPrecision')
      .attr('clip-path', 'url(#ellipse-clip)');

    const eyelid = eyeGroup.append('path')
      .attr('id', 'eyelid')
      .attr('d', path_eyelid)
      .style('fill', '#832990')
      .style('stroke', '#832990')
      .style('stroke-width', 1)
      .style('shape-rendering', 'geometricPrecision');

    clearInterval(this.blinkInterval);

    this. blinkInterval = setInterval(() => {
      this.closeEye();
    }, this.getRndInteger(1500, 6000));
  }


  getRndInteger(min: number, max: number) {
    return Math.floor(Math.random() * (max - min) ) + min;
  }


  closeEye() {

    const path_eyelid = 'M' + (-this.x) + ', 0 Q' + (-0.6 * this.x) + ',' + (-this.y) + ' 0,' + (-this.y) + ' Q' + (0.6 * this.x) + ',' + (-this.y) + ' ' + this.x + ',0 Q' + (0.6 * this.x) + ',' + (-0.5 * this.y) + ' 0,' + (-0.5 * this.y) +
                ' Q' + (-0.6 * this.x) + ',' + (-0.5 * this.y) + ' ' + (-this.x) + ', 0 Z' ;

    const path_eye = 'M' + (-this.x) + ', 0 Q' + (-0.6 * this.x) + ',' + (-this.y) + ' 0,' + (-this.y) + ' Q' + (0.6 * this.x) + ',' + (-this.y) + ' ' + this.x + ',0 Q' + (0.6 * this.x) + ',' + (this.y) + ' ' + '0,' + this.y +
                ' Q' + (-0.6 * this.x) + ',' + (this.y) + ' ' + (-this.x) + ', 0 Z';

    d3.select('#eyelid').transition().ease(d3.easeLinear).duration(100).attr('d', path_eye).transition().ease(d3.easeLinear).duration(100).attr('d', path_eyelid);
  }

  changeMode(mode: string) {
    if (this.svg) {
      if (mode === 'dark-mode') {
        this.svg.select('#iris').transition().ease(d3.easeLinear).duration(200).attr('r', (this.y * 0.5));
      } else {
        this.svg.select('#iris').transition().ease(d3.easeLinear).duration(200).attr('r', (this.y * 0.35));
      }
    }
  }

  moveEye(mouseX: number, mouseY: number) {
    const xOffset = this.x * 0.45;
    const yOffset = this.y * 0.3;

    const leftOffset = window.innerWidth * 0.75 + (this.x/2);
    const topOffset = window.innerHeight * 0.3 + (this.y/2);

    let newX: number;
    let newY: number;

    if (mouseX < leftOffset) {
      newX = -xOffset + (mouseX / leftOffset * xOffset);
    } else {
      newX = (mouseX - leftOffset) / (window.innerWidth - leftOffset) * xOffset;
    }

    if (mouseY < topOffset) {
      newY = -yOffset + (mouseY / topOffset * yOffset) + (this.y * 0.15);
    } else {
      newY = (mouseY - topOffset) / (window.innerHeight - topOffset) * yOffset + (this.y * 0.15);
    }

    this.svg.select('#iris').attr('cx', newX).attr('cy', newY);
    this.svg.select('#eyeColor').attr('cx', newX).attr('cy', newY);

  }


  drawLines(first: boolean) {

    const path_nose = "M50.5,0.8L4.5,189.9L39.7,189.9";

    const path_eyebrow = "M152,36.5c-15.1-20-39-33-66-33C40.4,3.5,3.5,40.4,3.5,86v44.1";

    const lineGroup = this.svg.append('g')
      .attr('transform', 'translate(' + [ this.offsetX, (this.offsetY + (this.height * 0.086))  ] + '), scale(' + this.scale + ')');

    const nose = lineGroup.append('path')
      .attr('d', path_nose)
      .attr('id', 'nose')
      .attr('stroke', first ? 'transparent' : '#ccc')
      .attr('stroke-width', this.width * 0.015 > 8 ? this.width * 0.015 : 8)
      .attr('fill', 'none')
      .style('shape-rendering', 'geometricPrecision');

    const lineGroup2 = this.svg.append('g')
      .attr('transform', 'translate(' + [ (this.offsetX + (this.width * 0.224)), this.offsetY ] + '), scale(' + this.scale + ')');

    const eyebrow = lineGroup2.append('path')
      .attr('d', path_eyebrow)
      .attr('id', 'eyebrow')
      .attr('stroke', '#ccc')
      .attr('stroke-width', this.width * 0.015 > 8 ? this.width * 0.015 : 8)
      .attr('fill', 'none')
      .style('shape-rendering', 'geometricPrecision');

    const totalLength_path_nose = nose.node().getTotalLength();
    const totalLength_path_eyebrow = eyebrow.node().getTotalLength();

    if (first) {

      eyebrow.attr('stroke-dasharray', totalLength_path_eyebrow + ' ' + totalLength_path_eyebrow )
        .attr('stroke-dashoffset', totalLength_path_eyebrow )
        .transition()
        .duration(600)
        .ease(d3.easeLinear)
        .attr('stroke-dashoffset', 0);

      setTimeout(() => {
        nose.attr('stroke', '#ccc')
          .attr('stroke-dasharray', totalLength_path_nose + ' ' + totalLength_path_nose )
          .attr('stroke-dashoffset', totalLength_path_nose )
          .transition()
          .duration(500)
          .ease(d3.easeLinear)
          .attr('stroke-dashoffset', 0);
      }, 600);

    }

  }

  drawHair() {
    const path = "M254.2,141v232.7c-0.4,41.2,27.8,60.8,65.1,60.8c70.2,0,78.6-66.9,76.1-65.3c-31.3,19.2-77.7,11.1-60.2-60.2c8-37.6,23-84.6,23-127.6C358,81.2,276.9,0,176.8,0C90.5,0,18.3,60.2,0,141h254H254.2z";

    this.svg.append('path')
      .attr('d', path)
      .style('fill', '#000')
      .attr('transform', 'translate(' + [ (this.offsetX + (this.width * 0.0175)), (this.offsetY + (this.height * -0.3))  ] + '), scale(' + this.scale + ')');
  }

  drawMouth() {
    const path = "M33.3,3.6L33.3,3.6C29.7,1.2,25.2-0.2,20.5,0C9.6,0.5,0.6,9.3,0,20.2c-0.7,12.3,9.1,22.5,21.3,22.5C9.2,42.7-0.6,52.9,0,65.3C0.6,76,9.3,84.8,20,85.4c5.3,0.3,10.2-1.3,14.1-4.2l0,0l45.8-38.5L35,4.9C34.5,4.5,33.9,4,33.3,3.6L33.3,3.6z"

    this.svg.append('path')
      .attr('d', path)
      .style('fill', '#f27fb2')
      // .attr('stroke', '#000')
      // .attr('stroke-width', window.innerWidth * 0.004)
      // .attr('fill', 'none')
      .attr('transform', 'translate(' + [ (this.offsetX + (this.width * 0.174)), (this.offsetY + (this.height * 0.556))  ] + '), scale(' + this.scale + ')');
  }

  drawEar() {
    const path = "M8.5,0C28,0,43.8,15.8,43.8,35.2c0,11.8-5.8,22.3-14.7,28.6c2.3,3.7,3.7,8.1,3.7,12.9c0,13.4-10.8,24.2-24.2,24.2H0L0,0L8.5,0z";
    const x = 260.839 / 450 * this.width;
    this.svg.append('path')
      .attr('d', path)
      .style('fill', '#ccc')
      // .attr('stroke', '#000')
      // .attr('stroke-width', window.innerWidth * 0.004)
      // .attr('fill', 'none')
      .attr('transform', 'translate(' + [ (this.offsetX + (this.width * 0.787)), (this.offsetY + (this.height * 0.222))  ] + '), scale(' + this.scale + ')');
  }

  drawCheek() {

    const group = this.svg.append('g')
      .attr('transform', 'translate(' + [ (this.offsetX + (this.width * 0.485)), (this.offsetY + (this.height * 0.535)) ] + ')');

    group.append('circle')
      .attr('r', this.width * 0.22)
      .attr('cx', 0)
      .attr('cy', 0)
      .style('fill', '#9fddf9')
      .style('opacity', 0.45)
      .attr('pointer-events', 'none')
      .style('mix-blend-mode', 'color-dodge');
  }

  drawHand() {

    const path = "M95.1,194.6c6.2,0,11.3-5.1,11.3-11.3v-65.9c0-5,1.9-9.7,5.5-13.3l24.5-24c3.7-3.7,7.2-5.5,10.9-5.5c0,0,0,0,0,0c3.7,0,7.2,1.8,10.9,5.5l5.9,5.8l33.2-33.1l-40.1-40C149,4.5,138,0,126.3,0c0,0,0,0,0,0c-11.7,0-22.7,4.6-30.9,12.8c0,0-0.1,0.1-0.2,0.1L13.1,82.9C4.6,91.4,0,102.7,0,114.6v68.2c0,5.8,4.1,10.7,9.5,11.6c3.3,0.5,6.6-0.4,9.1-2.6c2.5-2.2,4-5.3,4-8.6v-61.6c0-1.4,1.2-2.6,2.6-2.6h0.1c1.4,0,2.6,1.2,2.6,2.6v61.6c0,6.2,5.1,11.3,11.3,11.3s11.3-5.1,11.3-11.3v-61.6c0-1.4,1.2-2.6,2.6-2.6h0.1c1.4,0,2.6,1.2,2.6,2.6v61.6c0,6.2,5.1,11.3,11.3,11.3s11.3-5.1,11.3-11.3v-61.6c0-1.4,1.2-2.6,2.6-2.6h0.1c1.4,0,2.6,1.2,2.6,2.6v61.6C83.8,189.5,88.9,194.6,95.1,194.6z";

    const handGroup = this.svg.append('g')
    .attr('transform', 'translate(' + [ (this.offsetX + (this.width * 0.373)), (this.offsetY + (this.height * 0.562))  ] + '), scale(' + this.scale + ')');

    handGroup.append('path')
      .attr('d', path)
      .style('fill', '#ccc');


    const data = [ { x: 0 }, { x: 27.9 }, { x: (27.9 * 2) }, { x: (27.9 * 3) } ];

    handGroup.selectAll('circle.nail')
      .data(data)
      .enter()
      .append('circle')
      .attr('class', 'nail')
      .attr('r', 8.65)
      .attr('cx', (d) => d.x + 11.15)
      .attr('cy', 179)
      .style('fill', '#832990');


    handGroup.selectAll('rect.hand')
      .data(data)
      .enter()
      .append('rect')
      .attr('class', 'hand')
      .attr('width', 17.3)
      .attr('height', 17.3)
      .attr('x', (d) => d.x + 2.5)
      .attr('y', 179)
      .style('fill', '#832990');

  }

}

